import { AfterContentInit, Component, ContentChild, Input, OnInit, Pipe } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FieldDictionaryDto, LocalFormData, reportDesignerDto, SingleResponseModel } from 'src/app/tabms/models/base/base';
import { BaseService } from 'src/app/tabms/services/base/base.service';
import { FieldsConfigService } from 'src/app/tabms/services/global/fields-config.service';
import { EDITSUCCESS, OPERERROR, SAVESUCCESS } from 'src/app/tabms/tab-consts';
import { BaseUploadTemplateComponent } from '../base-upload-template/base-upload-template.component';
import { MatDialog } from '@angular/material/dialog';
import { FieldDictionaryListService } from 'src/app/tabms/services/global/field-dictionary-list.service';
import { PermissionsListService } from 'src/app/tabms/services/global/permissions-list.service';
import { firstValueFrom, Subject, take, takeUntil, timeout } from 'rxjs';
import { FormValidationService } from 'src/app/tabms/services/validation/form-validation/form-validation.service';
import { de } from 'date-fns/locale';
import { SessionWrapperService } from 'src/app/tabms/services/session/session-wrapper.service';
import { ImageHelperService } from 'src/app/tabms/services/global/image-helper.service';
import { DynamicSetFormValidatorsService } from 'src/app/tabms/services/global/dynamic-set-form-validators.service';
import { validate } from 'src/app/tabms/shared/utils/form-validation.utils';

@Component({
  selector: 'app-base-entry',
  templateUrl: './base-entry.component.html',
  styleUrl: './base-entry.component.scss'
})
export class BaseEntryComponent<T> implements OnInit, AfterContentInit {
  //#region inputs
  @Input() set service(_service) {
    if (!_service) return;
    this.serviceInstance = _service;
  }

 
  @Input() canEdit :boolean=true;
  @Input() canDelete:boolean =true;
  @Input() canCreate:boolean =true;

  @Input() disableActionsFieldName?:string ;
  @Input() disableActionsValue?:any ;
  //#endregion

  @ContentChild('formComponent') formComponent;

  //#region public prop
  showCreate = false;
  serviceInstance;
  editId;
  headerClass = 'headerClass';
  title;
  form: FormGroup;
  screen: string;
  showReport: boolean;
  designReport: boolean;
  reportName: string;
  reportId: string;
  submited = false;
  permissions;
  systemMenuId: string;
  initialValues
  private destroy$: Subject<void> = new Subject<void>();
  ImageId: string;
  imagekey: string;

  // Flag to keep form open on successful add when Save & Copy is used
  private keepOpenOnNextSave = false;
  // flag to save&design report
  private SaveAndDesignReport = false;
  //#endregion

  //#region constructor
  constructor(
    private baseService: BaseService,
    public fieldsConfigService: FieldsConfigService<T>,
    public dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService,
    private fieldDictionaryListService: FieldDictionaryListService,
    private permissionListService: PermissionsListService,
    private sessionService: SessionWrapperService,
    private imageHelper: ImageHelperService,
    private dynamicSetFormValidation: DynamicSetFormValidatorsService
  ) {
    this.activatedRoute.params.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      this.systemMenuId = params['id'];
      this.fieldsConfigService.setMenuId(this.systemMenuId);
      this.fieldDictionaryListService.getPageFields(this.systemMenuId);
      this.permissionListService.getPage(this.systemMenuId);
    });

    this.fieldsConfigService.getData();
    this.screen = activatedRoute.snapshot.url[0].path;
  }
  //#endregion

  //#region lifecycle hooks
  ngOnInit() {
    // console.log("serviceInstance", this.serviceInstance);

    //this.setValidators();
    this.permissionListService
      .getPagePermissions()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          if (res) {
            this.permissions = res;
            // console.log("TEMP PERMISSION", this.permissions)
          }
        }
      });

   
  }

  ngAfterContentInit() {
    this.baseService.formInitialized.pipe(take(1)).subscribe((res) => {
      console.log('form initialized', res);
      this.form = this.formComponent.form;
      this.initialValues = this.form.getRawValue(); //save intial values to use in reset
      console.log('form entry', this.form)
      this.initializationCode();
    });
  }
  //#endregion

  //#region initialization
  initializationCode() {
    //show or hide create form and recieve id in case of edit
    this.baseService.createFormDisplay.pipe(takeUntil(this.destroy$)).subscribe((res) => {
      // debugger;
      if (!res) return;
      this.showCreate = res?.show;
      // console.log('show', this.showCreate);
       console.log('id', res?.id);
      this.editId = res?.id;

      this.dynamicSetFormValidation.setValidators(this.form, this.systemMenuId, this.destroy$, !this.editId);
      if (this.editId) {
        this.title = this.translate.instant('edit');
        this.getById(this.editId);
      }
      this.baseService.sendEditId.next(res?.id);
    });

    // recieve save action
    this.baseService.saveForm.pipe(takeUntil(this.destroy$)).subscribe((value: boolean) => {
      // console.log('save', value);
      this.onSubmit();
    });

    // recieve clear action
    this.baseService.clearForm.pipe(takeUntil(this.destroy$)).subscribe((value: boolean) => {
      this.form.reset();
      this.form.patchValue(this.initialValues); //reset to ititial values

      // Call only if it exists
      if (this.formComponent && typeof (this.formComponent as any).resetImageState === 'function') {
        (this.formComponent as any).resetImageState();
      }
       if (this.formComponent && typeof (this.formComponent as any).resetFileState === 'function') {
        (this.formComponent as any).resetFileState();
      }
      if (this.formComponent && typeof (this.formComponent as any).tabPermissionTypeCode) {
        (this.formComponent as any).tabPermissionTypeCode = null;
      }
      // this.baseService.phoneReset.next(true);
      // console.log(value, this.form.value)
    });

    // recieve temporary save or restore action
    this.baseService.saveRetrieveLocalData.pipe(takeUntil(this.destroy$)).subscribe((saveorRetrieve: number) => {
      if (saveorRetrieve == 1)
        // temporary save
        this.saveLocalData();
      else if (saveorRetrieve == 2)
        // restore
        this.retrieveLocalData();
    })

    this.baseService.uploadfromExcel.pipe(takeUntil(this.destroy$)).subscribe((printListFields) => {
      if (printListFields) {
        let extraDownloadProperties = this.formComponent.beforeDownloadTemplateWork(); //['password', 'empCode'];
        this.dialog.open(BaseUploadTemplateComponent, {
          width: '800px',
          direction: this.baseService.getDirection(),
          data: {
            service: this.serviceInstance,
            displayListFields: printListFields,
            extraDownloadProperties: extraDownloadProperties,
            type: 1
          } // 1 for one row and 0 for list
        });
      }
    });
    // recieve upload from excel action
    this.baseService.uploadedData.pipe(takeUntil(this.destroy$)).subscribe((value: object) => {
      this.setUploadedData(value);
    });

    // recieve show report action
    this.baseService.showReport.pipe(takeUntil(this.destroy$)).subscribe({
      next: (report: reportDesignerDto) => {
        debugger;
        this.showReport = true;
        this.reportName = report.reportfilename;
        this.reportId = report.id
        this.onSubmit();
        // this.displayReport(this.editId);
      }
    });
this.baseService.designReport.pipe(takeUntil(this.destroy$)).subscribe({
      next: (report: reportDesignerDto) => {
        debugger;
        this.designReport = true;
        this.reportName = report.reportfilename;
        this.reportId = report.id
        this.onSubmit();
        // this.displayReport(this.editId);
      }
    });
     // Listen to Save & Copy flag to control cancel behavior
  
  
    this.baseService.keepFormOpenOnSave
      .pipe(takeUntil(this.destroy$))
      .subscribe((keep) => {
        this.keepOpenOnNextSave = !!keep;
      });
         // Listen to Save & Desgin behavior
    this.baseService.saveAndDesgin
      .pipe(takeUntil(this.destroy$))
      .subscribe((Save) => {
        this.SaveAndDesignReport = !!Save;
        this.onSubmit();
      });

  }

  cancelForm() {
    this.form.reset();
    this.form.patchValue(this.initialValues); //reset to ititial values
    this.submited = false;
    this.baseService.createFormDisplay.next({ show: false, id: null });
  }
  //#endregion

  //#region crud
  onSubmit() {
    // debugger;
    this.submited = true;
    if (this.formComponent.createUserCheck) {
      this.add();
    }
    else {
      if (validate(this.form)) {
        if (!this.editId) this.add();
        else this.update();
      }
    }

  }

  async add() {
    console.log('add', this.form.value);
    console.log("this.form.getRawValue() ", this.form.getRawValue());


    const asyncBeforeSaveWork = this.formComponent.beforeSaveWork_async ? await this.formComponent.beforeSaveWork_async() : true;
    const syncBeforeSaveWork = this.formComponent.beforeSaveWork ? this.formComponent.beforeSaveWork() : true;


    if (syncBeforeSaveWork && asyncBeforeSaveWork) {
      // debugger
      //--test 2025_07_10
      let formData: T = this.form.getRawValue() //this.form.value;

      // Object.keys(formData).forEach(key => {
      //   if (formData[key] === null) {
      //     delete formData[key];
      //   }
      // });

      Object.keys(formData).forEach(key => {
        if (key.toLowerCase() === 'branchid' && formData[key] === null) {
          formData[key] = this.sessionService.DefaultBranchID;
        }

      });

      if (this.formComponent.hasImage) {
        formData = await this.imageHelper.formHasImage(formData, this.destroy$);
      }

      // console.log('user form', formData);
      this.serviceInstance.create(formData).pipe(takeUntil(this.destroy$)).subscribe(
        async (res) => {
          // debugger

          let id = res?.result == null ? res.id : res.result.id;
          // console.log('id', id);
          if (this.showReport) this.displayReport(id);
          if (this.designReport || this.SaveAndDesignReport) this.displayReportDesigner(id);
          this.baseService.showSuccessMessage(SAVESUCCESS);
          this.removeLocalStorage();
          if (this.formComponent.afterSaveWork) {
            this.formComponent.afterSaveWork(id)
          }
          else if (this.formComponent.afterSaveWork_async) {
            await this.formComponent.afterSaveWork_async(id)
          }
          if (this.keepOpenOnNextSave) {
            // Keep the form open in create mode for next entry (copy behavior)
            this.baseService.createFormDisplay.next({ show: true, id: '' });
            this.keepOpenOnNextSave = false; // reset local flag
          } else {
            this.cancelForm();
          }
          this.baseService.refreshTable.next(true);
          this.serviceInstance.channel.postMessage('new-item-added');

        },
        (err) => {
          console.log('err', err);
          this.baseService.showErrorMessage(OPERERROR);
        }
      );
    }
  }

  async update() {
    //
    console.log('update', this.form.value);

    const asyncBeforeUpdateWork = this.formComponent.beforeUpdateWork_async ? await this.formComponent.beforeUpdateWork_async() : true;
    const syncBeforeUpdateWork = this.formComponent.beforeUpdateWork ? this.formComponent.beforeUpdateWork() : true;

    if (syncBeforeUpdateWork && asyncBeforeUpdateWork) {

      // let formData: T = { ...this.form.value, id: this.editId };
      let formData: T = { ...this.form.getRawValue(), id: this.editId };
      if (this.formComponent.hasImage) {
        formData = await this.imageHelper.formHasImage(formData, this.destroy$);
      }

      this.serviceInstance.update(this.editId, formData).pipe(takeUntil(this.destroy$)).subscribe({
        next: async (res) => {
          let id = this.editId;
          if (this.showReport) this.displayReport(id);
          if (this.designReport || this.SaveAndDesignReport) this.displayReportDesigner(id);
          this.baseService.showSuccessMessage(EDITSUCCESS);
          if (this.formComponent.afterUpdateWork) {
            this.formComponent.afterUpdateWork(id)
          }
          else if (this.formComponent.afterUpdateWork_async) {
            await this.formComponent.afterUpdateWork_async(id)
          }
          if (this.keepOpenOnNextSave) {
            // Keep the form open in create mode for next entry (copy behavior)
            this.baseService.createFormDisplay.next({ show: true, id:  '' });
            this.keepOpenOnNextSave = false; // reset local flag
          } else {
            this.cancelForm();
          }
          // this.cancelForm();
          this.baseService.refreshTable.next(true);
          this.serviceInstance.channel.postMessage('new-item-added');
        },
        error: (err) => {
          console.log('err', err);
          this.baseService.showErrorMessage(OPERERROR);
        }
      });
    }
  }

  getById(id) {
    this.serviceInstance.get(id).pipe(takeUntil(this.destroy$)).subscribe((res: SingleResponseModel<T>) => {
      let data;
      if (res?.result) data = res.result;
      else data = res;
      this.form.patchValue(data);
      this.formComponent.afterGetDataWork ? this.formComponent.afterGetDataWork(data) : null;
    });
  }
  //#endregion

  //#region report
  displayReport(id) {
   // debugger;
    let properties = { Id: this.reportId, reportName: this.reportName, parameters: { id: id } };
    let reportsUrl = `${window.location.origin}/reports/${JSON.stringify(properties)}`;
    window.open(reportsUrl);
    this.showReport = false;
    this.SaveAndDesignReport = false;
    this.baseService.createFormDisplay.next({ show: false, id: null });
    this.baseService.refreshTable.next(true);
    this.cancelForm();
  }
  displayReportDesigner(id) {
    //debugger;
   // let properties = { Id: this.reportId, reportName: this.reportName, parameters: { id: id } };
    let properties = {Id: this.reportId ?? id };
    let reportsUrl = `${window.location.origin}/report-design/${JSON.stringify(properties)}`;
    window.open(reportsUrl);
    this.designReport = false;
    this.baseService.createFormDisplay.next({ show: false, id: null });
    this.baseService.refreshTable.next(true);
    this.cancelForm();
  }
 
  //#endregion

  //#region local data
  saveLocalData() {
    console.log('saveLocalData', this.form.value);

    // const localFormData: LocalFormData = { screen: this.screen, showrestorebtn: true, formvalue: this.form.value };
    const localFormData: LocalFormData = { screen: this.screen, showrestorebtn: true, formvalue: this.form.getRawValue() };
    let localDataArray: LocalFormData[];
    localDataArray = JSON.parse(localStorage.getItem('localFormData') || '[]');
    let indexToUpdate = localDataArray.findIndex((x) => x.screen == this.screen);
    if (indexToUpdate > -1) localDataArray[indexToUpdate] = localFormData;
    else localDataArray.push(localFormData);

    localStorage.setItem('localFormData', JSON.stringify(localDataArray));
  }

  retrieveLocalData() {
    const localDataArray: LocalFormData[] = JSON.parse(localStorage.getItem('localFormData') || '[]');
    const localData = localDataArray.find((x) => x.screen == this.screen);
    if (localData) {
      this.form.patchValue(localData.formvalue);
      // debugger
      this.formComponent.afterGetDataWork ? this.formComponent.afterGetDataWork(localData.formvalue) : null;
    }
  }

  removeLocalStorage() {
    let localDataArray: LocalFormData[];
    localDataArray = JSON.parse(localStorage.getItem('localFormData') || '[]');
    let indexToDelete = localDataArray.findIndex((x) => x.screen == this.screen);
    if (indexToDelete > -1) localDataArray.splice(indexToDelete, 1);
    localStorage.setItem('localFormData', JSON.stringify(localDataArray));
    this.baseService.saveRetrieveLocalData.next(0);
  }
  //#endregion

  //#region import from excel
  setUploadedData(value) {
    this.form.patchValue(value);
  }
  //#endregion

  //region destory subscribtion
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.baseService.createFormDisplay.next(null)
    this.fieldsConfigService.setMenuId('');
  }
  //end region
}
